/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Bad request model
 * @export
 * @interface BadRequest
 */
export interface BadRequest {
    /**
     * Bad request message
     * @type {string}
     * @memberof BadRequest
     */
    error: string;
}

/**
 * Check if a given object implements the BadRequest interface.
 */
export function instanceOfBadRequest(value: object): value is BadRequest {
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function BadRequestFromJSON(json: any): BadRequest {
    return BadRequestFromJSONTyped(json, false);
}

export function BadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'],
    };
}

export function BadRequestToJSON(json: any): BadRequest {
    return BadRequestToJSONTyped(json, false);
}

export function BadRequestToJSONTyped(value?: BadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

